module.exports = __webpack_public_path__ + "assets/location.32d8250b.svg";